const COMMENT_TYPE_SYSTEM: string = 'system';

export default COMMENT_TYPE_SYSTEM;
